import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sample-creative-cloud-libraries"
    }}>{`Sample Creative Cloud Libraries`}</h1>
    <p>{`Need some sample Library content to experiment with?`}</p>
    <p>{`If you're looking to quickly add some content to your own Creative Cloud Libraries for testing, you can follow or make copies of these public Libraries:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://assets.adobe.com/public/a3f9dbc4-cdc0-40dc-65ea-23f8b7e95ac6#"
        }}>{`Dan Stiles`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://assets.adobe.com/public/b623f987-ea2b-418b-7746-e5dc31b6596d"
        }}>{`Fonts for Screen Design`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://assets.adobe.com/public/4f8c52b5-fd77-429b-640f-561618adde81"
        }}>{`Alice Lee`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://assets.adobe.com/public/06cb8dc3-921f-4be6-64fa-f04de9b0a752"
        }}>{`Adobe Colors`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://assets.adobe.com/public/ec584d24-ba5d-4f1b-5eaf-918ecde6c5cf"
        }}>{`Eva Icons`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      